import {getRights} from '@/utils/auth'

export function CheckRight(modulename,needright)
{

  var weberpMappingList=
  [
      {"web":"quoteAccountWF","erp":"63aa78c6-9bb7-4af5-965f-f9a9e781f986"},    //报价开户申请
      {"web":"quoteApplay","erp":"abb72ea0-e283-40b0-b822-c40864e087c0"},       //报价申请单
      {"web":"estimate","erp":"EstimateModule"},                                //估价单
      {"web":"procedureParam","erp":"de7b56ae-a11a-4ded-86d6-8a13af2e24f5"},    //估价工序设定   -- 工艺参数
      {"web":"productDefined","erp":"c11ca21c-de76-4645-8a99-1b9339110dbb"},    //货品种类设定   -- 产品定义
      {"web":"pullWireSetting","erp":"QuoteRequesTPullWireSetting"},    //拉线设置页面
  ];

  //	SELECT * FROM  dbo.sys_module WHERE id in ('EstimateModule','c11ca21c-de76-4645-8a99-1b9339110dbb','de7b56ae-a11a-4ded-86d6-8a13af2e24f5','abb72ea0-e283-40b0-b822-c40864e087c0')

  if(typeof(modulename) === 'undefined' || modulename == null)
  {
      return true;
  }
  var erpRightsStr = getRights();
  var erpRights = JSON.parse(erpRightsStr);
  
  var webItem = weberpMappingList.filter(item => {return item.web.toLowerCase() === modulename.toLowerCase()})[0];

  if(typeof(webItem) !== 'undefined' && webItem != null)
  {
    var rightInfo = erpRights.filter(item => { return item.ModuleId.toLowerCase() ===  webItem.erp.toLowerCase() })[0];
    if(typeof(rightInfo) !== 'undefined' && rightInfo != null)
    {
      if(   rightInfo.RightLevel >= needright )
        {
           return true;
        }
        else
        {
            return false; //权限级别不够
        }
    }
    else
    {
      return false; //未在erp中配置权限
    }
  }
  else
  {
     return false; //未找到web菜单
  }
}



// WEBPACK FOOTER //
// ./src/api/global.js